import styled, { css } from "styled-components";

import { colorsPalettes, rgba, setFont, setFontVariant } from "@similarweb/styles";
import { MiniFlexTable } from "@similarweb/ui-components";

import MetricsCompareBars from "app/components/React/MetricsCompareBars/MetricsCompareBars";
import { CenteredFlexRow, FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Filters = styled(FlexColumn)`
    flex-grow: 1;
`;

export const DownloadExcelContainer = styled.span`
    margin: 0 8px 0 16px;
`;

export const Right = styled(FlexRow)`
    flex-grow: 0;
    align-items: center;
    margin-left: 10px;
`;

export const FiltersGrow = styled(FlexRow)`
    align-items: center;
    flex-grow: 1;
`;
export const SearchContainer = styled(FlexRow)`
    align-items: center;
    padding: 8px 16px 8px 0;
    height: 40px;
    border-top: 1px solid ${colorsPalettes.carbon[100]};

    .SearchInput-container {
        flex-grow: 1;
    }
    .SearchInput-container .SearchInput {
        height: 34px;
        background-color: ${colorsPalettes.carbon[0]};
        border: none;
        width: 100%;
        box-sizing: border-box;
        padding: 9px 2px 5px 50px;
        box-shadow: none;
        margin-bottom: 0;
        &:focus {
            box-shadow: none !important;
            border: none;
        }
    }
`;

export const Separator = styled.hr<{ margin?: number }>`
    border-top-color: ${colorsPalettes.carbon[50]};
    margin: 0 24px;
`;

export const LoaderWrapper = styled(CenteredFlexRow)`
    min-height: 530px;
`;

export const Section = styled(FlexRow)<{ margin?: number }>`
    padding: 0 16px;
    align-items: center;
    ${({ margin }) =>
        margin &&
        css`
            margin: ${margin}px 0;
        `};
    width: 100%;
`;

const SectionContainer = styled.div`
    padding: 0 24px;
`;

export const SectionWrapper = styled(FlexRow)`
    justify-content: space-between;
    align-items: center;
`;

export const NetworksFilterWrapper = styled.span`
    margin-right: 8px;
`;

export const TitleWrapper = styled.div`
    padding: 20px;
`;

export const StyledBox = styled(FlexColumn)`
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    margin: 24px 12px;
    width: calc((100% - 52px) / 2);
    min-height: 260px;
`;

export const DistributionBox = styled.div`
    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 6px;
    margin: 24px;
`;

export const DistributionSection = styled(FlexRow)`
    padding: 0 12px;
`;

export const CompetitiveCompareBarsTitle = styled.div`
    ${setFontVariant("subtitle2", colorsPalettes.carbon[400])};
    margin: 24px 24px 10px 24px;
`;

export const CompetitiveCompareBarsStyled = styled(MetricsCompareBars)<{
    isFetching: boolean;
    items: any;
}>`
    ${css`
        flex-grow: 1;
        margin: 0 24px 24px 24px;
    `}
`;

export const MetricTitleWithDropdownWrapper = styled(FlexRow)`
    justify-content: space-between;
    padding: 20px 24px 24px 24px;
`;

export const TitleWithDropdownWrapper = styled.div`
    padding-right: 2px;
`;

export const Text = styled.label<{ fontSize?: number; fontWeight?: number; opacity?: number }>`
    white-space: nowrap;
    font-family: "DM Sans";
    cursor: inherit;
    ${({ fontSize = 14, fontWeight = 500 }) =>
        setFont({ $size: fontSize, $color: colorsPalettes.carbon[500], $weight: fontWeight })};
`;

export const DropdownWrapper = styled.div`
    margin-top: 2px;
    svg {
        path {
            fill: ${colorsPalettes.blue[400]} !important;
        }
    }

    .dropdown-borderless--no-border-button {
        > div {
            font-family: "DM Sans" !important;
        }
    }
`;

export const StyledCellCategory = styled.div`
    color: ${colorsPalettes.blue[400]};
    cursor: pointer;
`;

export const StyledTable: any = styled(MiniFlexTable)`
    &.MiniFlexTable {
        padding-bottom: 0;
    }

    .MiniFlexTable-column {
        &:first-child {
            .MiniFlexTable-cell {
                padding-left: 24px;
                padding-right: 24px;
            }
            .MiniFlexTable-headerCell {
                padding-left: 24px;
            }
        }

        &:not(:first-child) {
            .MiniFlexTable-cell {
                padding-right: 24px;
            }
            .MiniFlexTable-headerCell {
                padding-right: 24px;
            }
        }

        .MiniFlexTable-cell {
            height: 40px;
            font-size: 14px;

            &:not(:first-child) {
                border-top: 1px solid ${colorsPalettes.carbon[50]};
            }

            .cell-innerText {
                white-space: nowrap;
            }

            > div {
                height: 100%;
                align-items: center;
                display: flex;
            }
        }
    }

    .MiniFlexTable-headerCell {
        margin-bottom: 2px;
        font-weight: 500;
        font-size: 12px;
        color: ${rgba(colorsPalettes.carbon[500], 0.6)};
    }
`;

export const HeaderWithMarker = (domain) =>
    function () {
        const Wrapper = styled(FlexRow)`
            align-items: center;
        `;
        const Marker = styled.div`
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: ${({ color }) => color};
            margin-right: 8px;
            flex-shrink: 0;
        `;
        const Domain = styled.span`
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
        `;
        return (
            <Wrapper>
                <Marker color={domain.color} />
                <Domain> {domain.name} </Domain>
            </Wrapper>
        );
    };
